import React from "react";
export const EditableItemLayout = (props: any) => (
  <div className="ting-header md:text-md mt-10 mb-2">{props.children}</div>
);
